module.exports = __webpack_public_path__ + "img/testimonials-7.6bdbfc68.jpg";